const DAYS_PER_WEEK = 7;
const DAYS_PER_MONTH = 30;

/**
 * Formats a signed day offset into a human-friendly relative label.
 * Positive values are in the future ("in ..."), negative values are in the past ("... ago").
 * Examples: 0 -> "Today", 1 -> "tomorrow", -1 -> "yesterday", 7 -> "in 1 week",
 * -35 -> "1 month ago".
 */
export function formatBirthdayDistance(daysAway: number): string {
    if (daysAway === 0) {
        return "Today";
    }
    if (daysAway === 1) {
        return "tomorrow";
    }
    if (daysAway === -1) {
        return "yesterday";
    }

    const value = describeDuration(Math.abs(daysAway));
    return daysAway > 0 ? `in ${value}` : `${value} ago`;
}

function describeDuration(absDays: number): string {
    if (absDays < DAYS_PER_WEEK) {
        return `${absDays} days`;
    }
    if (absDays < DAYS_PER_MONTH) {
        const weeks = Math.round(absDays / DAYS_PER_WEEK);
        return weeks === 1 ? "1 week" : `${weeks} weeks`;
    }
    const months = Math.round(absDays / DAYS_PER_MONTH);
    return months === 1 ? "1 month" : `${months} months`;
}
